import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getProducts = async () => {
  const response = await axiosInstance.get('Product/get-products');
  debugger;
  return response.data;
};

export const getProductById = async (id) => {
  const response = await axiosInstance.get(`Product/get-product/${id}`);
  return response.data;
};

export const addProduct = async (product) => {
  const res = await axiosInstance.post('product/add-product', product);
  return res.data;
};

export const updateProduct = async (product) => {
  const response = await axiosInstance.post('product/update-product', product);
  return response.data;
};

export const deleteProduct = async (id) => {
  await axiosInstance.delete(`Product/delete-product/${id}`);
};

export const searchProducts = async (paramsObj) => {
  const response = await axiosInstance.get('product/search', { params: paramsObj });
  return response.data;
};